<script>
import BaseFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';
import { DevicesService } from '@/services/devices.service';

export default {
  name: 'PhoneFilter',

  extends: BaseFilter,

  data() {
    return {
      name: 'phone'
    };
  },

  methods: {
    getData() {
      return DevicesService.getFilteredPhones({ search: this.search })
        .then(({ data }) => {
          return data.data;
        })
        .catch(console.error);
    }
  }
};
</script>
